/**
 * hex转rgb
 * @param str
 * @returns
 */
export function setHexToRgba(str: string, opacity: number) {
  const reg = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;
  if (!reg.test(str)) {
    return;
  }
  let newStr = str.toLowerCase().replace(/#/g, '');
  const len = newStr.length;
  if (len === 3) {
    let t = '';
    for (let i = 0; i < len; i++) {
      t += newStr.slice(i, i + 1).concat(newStr.slice(i, i + 1));
    }
    newStr = t;
  }
  const arr: number[] = []; // 将字符串分隔，两个两个的分隔
  for (let i = 0; i < 6; i = i + 2) {
    const s = newStr.slice(i, i + 2);
    arr.push(parseInt(`0x${s}`));
  }
  const [red, green, blue] = arr;
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}

export const toHex = (n: number) => `${n > 15 ? '' : 0}${n.toString(16)}`;

/**
 * 颜色对象转化为16进制颜色字符串
 * @param colorObj 颜色对象
 */
export const toHexString = (rgb: number[]) => {
  const [r, g, b, a = 1] = rgb;
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${a === 1 ? '' : toHex(Math.floor(a * 255))}`;
};

export function getRgb(rgba: string) {
  const arr = (rgba.split('(')[1] || '')
    .split(',')
    .slice(0, -1)
    .map(item => Number(item));
  return arr;
}

export function setRgbaOpacity(rgba: string, opacity: number) {
  const arr = (rgba.split('(')[1] || '')
    .split(',')
    .slice(0, -1)
    .map(item => Number(item));
  if (arr.length === 3) {
    return `rgba(${arr.join(', ')}, ${opacity})`;
  }
  return '';
}

export function rgbToHsv(arr: number[]) {
  let h = 0;
  let s = 0;
  let v = 0;
  const r = arr[0];
  const g = arr[1];
  const b = arr[2];
  arr.sort((a, b) => a - b);
  const max = arr[2];
  const min = arr[0];
  v = max / 255;
  if (max === 0) {
    s = 0;
  } else {
    s = 1 - min / max;
  }
  if (max === min) {
    h = 0; // 事实上，max===min的时候，h无论为多少都无所谓
  } else if (max === r && g >= b) {
    h = 60 * ((g - b) / (max - min)) + 0;
  } else if (max === r && g < b) {
    h = 60 * ((g - b) / (max - min)) + 360;
  } else if (max === g) {
    h = 60 * ((b - r) / (max - min)) + 120;
  } else if (max === b) {
    h = 60 * ((r - g) / (max - min)) + 240;
  }
  h = parseInt(h.toString());
  s = parseInt((s * 100).toString());
  v = parseInt((v * 100).toString());
  return [h, s, v];
}

export function hsvToRgb(arr: number[]) {
  const h = arr[0];
  let s = arr[1];
  let v = arr[2];
  s = s / 100;
  v = v / 100;
  let r = 0;
  let g = 0;
  let b = 0;
  const i = parseInt(((h / 60) % 6).toString());
  const f = h / 60 - i;
  const p = v * (1 - s);
  const q = v * (1 - f * s);
  const t = v * (1 - (1 - f) * s);
  switch (i) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
    default:
      break;
  }
  r = parseInt((r * 255.0).toString());
  g = parseInt((g * 255.0).toString());
  b = parseInt((b * 255.0).toString());
  return [r, g, b];
}

export function getColorsFromPrimary(primary: string) {
  const rgb = getRgb(setHexToRgba(primary, 1.0) || '');
  const hsv = rgbToHsv(rgb);
  const newHsv = [hsv[0], Math.max(5, hsv[1] - 30), Math.min(100, hsv[2] + 60)];
  const newRgb = hsvToRgb(newHsv);
  const textColor = `rgba(${newRgb[0]}, ${newRgb[1]}, ${newRgb[2]}, 1.0)`;
  const borderColor = setRgbaOpacity(textColor, 0.4);
  const backgroundColor = setRgbaOpacity(textColor, 0.08);
  return { textColor, borderColor, backgroundColor };
}

export function getVoiceColorsFromPrimary(primary: string) {
  const rgb = getRgb(setHexToRgba(primary, 1.0) || '');
  const rgbaPrimary = primary;
  const hsv = rgbToHsv(rgb);
  const midColor = hsvToRgb([hsv[0], hsv[1] + 18, hsv[2] + 14]);
  const rgbaMidColor = `rgba(${midColor[0]}, ${midColor[1]}, ${midColor[2]}, 1.0)`;
  const highLightColor = hsvToRgb([hsv[0], hsv[1] - 17, hsv[2] + 49]);
  const rgbaHighLightColor = `rgba(${highLightColor[0]}, ${highLightColor[1]}, ${highLightColor[2]}, 1.0)`;
  return { rgbaPrimary, rgbaMidColor, rgbaHighLightColor };
}
